var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-bar bar-bot message--cc",attrs:{"id":"cc-message"}},[_c('div',{staticClass:"bar--msg"},[_c('p',[_vm._v(_vm._s(_vm.$t("cc.message")))]),_c('button',{staticClass:"square-btn--green",attrs:{"id":"cc-allow","type":"button","value":_vm.$t('cc.button')}},[_c('span',[_vm._v(_vm._s(_vm.$t('cc.button')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }